import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor() { }

  data=new EventEmitter<any>
  updatedSideBar=new EventEmitter<any>
  allProjects=new EventEmitter<any>
  individualProject=new EventEmitter<any>

  private toggleState = new BehaviorSubject<boolean>(true);
  toggleState$ = this.toggleState.asObservable();


  getData(data:any){
    this.data.emit(data)
  }

  updateSideBar(data:any){
    this.updatedSideBar.emit(data)
  }

  shareProjects(data:any){
    this.allProjects.emit(data)
  }

  shareIndividualProject(data:any){
    this.individualProject.emit(data)
  }

  toggleSidebar() {
    const current = !this.toggleState.value;
    this.toggleState.next(current);

  }

  setState(state: boolean) {
    this.toggleState.next(state);
  }

  getCurrentSidebarState(): boolean {
    return this.toggleState.getValue();
  }

}
